import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from "./home";
import EighteenNineteen from './eighteenNineteen';
import Invite from "./invite";
import "./App.css";

class App extends Component {
  render() {
    const routes = [
      {
        path: "/",
        component: Home
      },
      {
        path: "/1819",
        component: EighteenNineteen
      },
      {
        path: "/invites/1819",
        component: Invite,
        props: {}
      },
      {
        path: "/invites/jaimerandall-3157",
        component: Invite,
        props: { name: "Jaime", league: "BSL" }
      },
      {
        path: "/invites/garethstephens-3246",
        component: Invite,
        props: { name: "Gareth", league: "BSL" }
      },
      {
        path: "/invites/peterdoyle-1345",
        component: Invite,
        props: { name: "Peter", league: "BSL" }
      },
      {
        path: "/invites/michaeltew-3786",
        component: Invite,
        props: { name: "Michael", league: "BSL" }
      },
      {
        path: "/invites/deanbreed-5424",
        component: Invite,
        props: { name: "Dean", league: "BSL" }
      },
      {
        path: "/invites/ginomurugesan-1245",
        component: Invite,
        props: { name: "Gino", league: "BSL" }
      },
      {
        path: "/invites/chrisloudon-5842",
        component: Invite,
        props: { name: "Chris", league: "BSL" }
      },
      {
        path: "/invites/noamgur-8473",
        component: Invite,
        props: { name: "Noam", league: "BSL" }
      },
      {
        path: "/invites/jameshickie-2713",
        component: Invite,
        props: { name: "James", league: "BSL" }
      },
      {
        path: "/invites/giannistzouganatos-1144",
        component: Invite,
        props: { name: "Giannis", league: "BSL" }
      },
      {
        path: "/invites/danielbracey-4317",
        component: Invite,
        props: { name: "Daniel", league: "BSL" }
      },
      {
        path: "/invites/alexwray-3136",
        component: Invite,
        props: { name: "Alex", league: "BSL" }
      },
      {
        path: "/invites/stecrane-5896",
        component: Invite,
        props: { name: "Ste", league: "BSL" }
      },
      {
        path: "/invites/alexandercox-4831",
        component: Invite,
        props: { name: "Alexander", league: "BSL" }
      },
      {
        path: "/invites/andyrose-1522",
        component: Invite,
        props: { name: "Andy", league: "BSL" }
      },
      {
        path: "/invites/paulfrancis-2465",
        component: Invite,
        props: { name: "Paul", league: "LUL" }
      },
      {
        path: "/invites/ianpocock-1553",
        component: Invite,
        props: { name: "Ian", league: "LUL" }
      },
      {
        path: "/invites/jamesmerritt-9141",
        component: Invite,
        props: { name: "Mez", league: "LUL" }
      },
      {
        path: "/invites/tobiastrombik-6834",
        component: Invite,
        props: { name: "Tobias", league: "LUL" }
      },
      {
        path: "/invites/martinnash-5742",
        component: Invite,
        props: { name: "Martin", league: "LUL" }
      },
      {
        path: "/invites/jayhall-8374",
        component: Invite,
        props: { name: "Jay", league: "LUL" }
      },
      {
        path: "/invites/rossfarquharson-7958",
        component: Invite,
        props: { name: "Ross", league: "LUL" }
      },
      {
        path: "/invites/darwingcarvajal-2786",
        component: Invite,
        props: { name: "Darwing", league: "LUL" }
      },
      {
        path: "/invites/oliverpeck-1798",
        component: Invite,
        props: { name: "Oliver", league: "LUL" }
      },
      {
        path: "/invites/edfite-9856",
        component: Invite,
        props: { name: "Ed", league: "LUL" }
      },
      {
        path: "/invites/pedrosantos-4486",
        component: Invite,
        props: { name: "Pedro", league: "LUL" }
      },
      {
        path: "/invites/jayshort-2864",
        component: Invite,
        props: { name: "Jay", league: "LUL" }
      },
      {
        path: "/invites/stephaneringsell-4276",
        component: Invite,
        props: { name: "Stephane", league: "LUL" }
      },
      {
        path: "/invites/joewilson-1350",
        component: Invite,
        props: { name: "Joe", league: "LUL" }
      },
      {
        path: "/invites/georgegraham-6485",
        component: Invite,
        props: { name: "George" }
      },
      {
        path: "/invites/ollielawson-4618",
        component: Invite,
        props: { name: "Ollie" }
      },
      {
        path: "/invites/robleary-4160",
        component: Invite,
        props: { name: "Rob" }
      },
      {
        path: "/invites/bobikelly-7465",
        component: Invite,
        props: { name: "Bobi" }
      },
      {
        path: "/invites/andrerodrigues-6178",
        component: Invite,
        props: { name: "Andre" }
      },
      {
        path: "/invites/jonnydundon-7861",
        component: Invite,
        props: { name: "Jonny" }
      },
      {
        path: "/invites/philbell-0453",
        component: Invite,
        props: { name: "Phil" }
      },
      {
        path: "/invites/adrianmichael-1678",
        component: Invite,
        props: { name: "Adrian" }
      },
      {
        path: "/invites/joeflagg-1645",
        component: Invite,
        props: { name: "Joe" }
      },
      {
        path: "/invites/richbuckley-1644",
        component: Invite,
        props: { name: "Rich" }
      },
      {
        path: "/invites/kevinsutton-4068",
        component: Invite,
        props: { name: "Kevin" }
      }
    ];

    return (
      <Router>
        <div>
          {routes.map((route, i) => (
            <Route
              key={i}
              path={route.path}
              exact
              render={props => <route.component {...props} {...route.props} />}
            />
          ))}
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js